export default IconRestore => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-restore" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M3.06 13a9 9 0 1 0 .49 -4.087" />
  <path d="M3 4.001v5h5" />
  <path d="M12 12m-1 0a1 1 0 1 0 2 0a1 1 0 1 0 -2 0" />
</svg>`;